<template>
    <div class="contact">
        <page-cover image-url="/images/contact.jpg" title="Get In Touch" description="For more information about any of our services, call us today to speak with one of our friendly and experienced consultants on 01753 444 008." />
        <section>
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
                    <div class="text-center section-bg py-8">
                        <h5 class="text-primary text-2xl font-semibold">Drop on in</h5>
                        <p class="text-xl mt-4">
                            Unit C, Tillermans Court, <br />Grenan Square, Greenford, UB6 0FT
                        </p>
                    </div>
                    <div class="text-center section-bg py-8">
                        <h5 class="text-primary text-2xl font-semibold">Give us a call</h5>
                        <p class="text-xl mt-4">
                            <a href="tel:01753444008">01753 444 008</a>
                        </p>
                    </div>
                    <div class="text-center section-bg py-8">
                        <h5 class="text-primary text-2xl font-semibold">Connect online</h5>
                        <p class="text-xl mt-4">
                            <a href="mailto:admin@early-years.com" target="_blank">admin@early-years.com</a>
                        </p>
                    </div>
                </div>
                <div class="mt-16 lg:mx-56">
                    <h3 class="text-primary text-center text-3xl font-semibold">or reach us right here…</h3>
                    <form class="mt-12 light-gray-bg p-4 lg:p-8" @submit.prevent="submitForm">
                        <div>
                            <label for="your-name">Your Name<sup>*</sup></label>
                            <input type="text" id="your-name" v-model="formData.Name" required>
                        </div>
                        <div class="mt-4">
                            <label for="email">Email Address<sup>*</sup></label>
                            <input type="email" id="email" v-model="formData.Email" required>
                        </div>
                        <div class="mt-4">
                            <label for="contact-no">Contact Number<sup>*</sup></label>
                            <input type="tel" id="contact-no" v-model="formData.Phone" required>
                        </div>
                        <div class="mt-4">
                            <label for="message">Your Message<sup>*</sup></label>
                            <textarea id="message" rows="4" v-model="formData.Message" required></textarea>
                        </div>
                        <div class="mt-8">
                            <button class="btn btn-secondary btn-full" :disabled="isFormValid">
                                <span v-if="!isLoading">Submit Form</span>
                                <span v-if="isLoading">Sending...</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import Swal from 'sweetalert2';
const isLoading = ref(false);
const formData = reactive({
    Name: '',
    Email: '',
    Phone: '',
    Message: ''
});

const message = reactive({
    to: ['admin@early-years.com'],
    subject: '',
    content: ''
})

function resetData() {
    formData.Name = '',
    formData.Email = '',
    formData.Phone = '',
    formData.Message = ''
}

const isFormValid = computed(() => {
    return (
        isLoading.value ||
        !formData.Name ||
        !formData.Email ||
        !formData.Phone ||
        !formData.Message
    )
})

async function submitForm() {
    isLoading.value = true;
    message.subject = "Contact email from Early Years website";

    message.content = "<h3>You have a new message from Early Years website.</h3>" +
        "<strong>Name: </strong>" + formData.Name + "<br />" +
        "<strong>Email: </strong>" + formData.Email + "<br />" +
        "<strong>Phone: </strong>" + formData.Phone + "<br />" +
        "<strong>Message: </strong>" + formData.Message + "<br />";

    try {
        const { data: result } = await $fetch('/api/sendmail', {
            method: 'post',
            body: message
        })
        if(result) {
            await Swal.fire({
                icon: 'success',
                title: 'Thank you for your message',
                text: 'Our team will get back to you shortly.',
                confirmButtonColor: '#313131',
            });
            isLoading.value = false;
            resetData();
        }
    } catch (error) {
        await Swal.fire({
            icon: 'error',
            title: 'An Error Occurred',
            text: 'Some error has occurred',
            confirmButtonColor: '#313131',
        });
        isLoading.value = false;
        resetData();
    }
};

useHead({
    title: 'Contact',
    link: [
        { rel: 'preload', as: 'image', href: '/images/contact.jpg', fetchpriority: 'high' },
    ],
});
</script>

<style lang="scss" scoped>
.contact {
}
</style>